import { useModal } from '@gluedigital/modal';
import { ChangeEvent } from 'react';
import { handleUserFront } from 'src/store/actions/userFront';
import { useAppDispatch, useAppSelector } from 'universal-scripts';

import './SelectUserFront.sass';

// los identificadores del enum no deben contener tildes ni otros caracteres especiales (espacios).
// los valores del enum pueden contener estos caracteres.

enum UsersFront {
	Delfi = 'Delfi',
	FactReview = 'FactReview',
	Faktoje = 'Faktoje',
	Lakmusz = 'Lakmusz',
	Newtral = 'Newtral',
	Ostro = 'Ostro'
}

const SelectUserFront = ({ isModal = false }: { isModal?: boolean }) => {
	const dispatch = useAppDispatch();
	const modal = useModal();
	const storeUserFront = useAppSelector((s: { userFront: string }) => s.userFront);

	const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
		dispatch(handleUserFront(e.target.value));
		if (isModal) {
			setTimeout(() => {
				modal.hide();
			}, 400);
		}
	};
	if (__DEV__) {
		return (
			<select id="select-user-front" value={storeUserFront} onChange={handleChange}>
				<option value="Anónimo" disabled>
					Anónimo
				</option>
				{Object.entries(UsersFront).map(([key, value]) => (
					<option key={key} value={key}>
						{value}
					</option>
				))}
			</select>
		);
	}
};

export default SelectUserFront;
